export default __webpack_public_path__ + "static/media/crm.4ba47afc.png";